<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">{{data.nzTitle}}</p>
    </div>
</div>

<div class="mx-4">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4" formArrayName="quantities">
                @for(quantityControl of quantities.controls; track idx; let idx = $index){
                    <div  [formGroupName]="idx" nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                        <nz-form-item>
                            <nz-form-label nzRequired>
                                Cantidad para {{ finalProducts[idx].article?.name }} ({{ getDisplayUnit() }})
                            </nz-form-label>
                            <nz-form-control nzErrorTip="Indique la cantidad de materia prima a actualizar">
                                <input onfocus="select()" formControlName="quantity" nz-input type="number"
                                    placeholder="Indique la cantidad de materia prima a actualizar" />
                            </nz-form-control>
                        </nz-form-item>
                        <!-- TODO: Uncomment this section if kg handling is introduced in the future. -->
                       <!--  @if (isKgProcess()) {
                        <nz-form-item>
                            <nz-form-label>
                                Cantidad en kg para {{ finalProducts[idx].article?.name }}
                            </nz-form-label>
                            <nz-form-control nzErrorTip="Indique la cantidad en kg">
                                <input onfocus="select()" formControlName="axuliaryQuantity" nz-input type="number"
                                    placeholder="Indique la cantidad en kg" />
                            </nz-form-control>
                        </nz-form-item>
                        } -->
                    </div>
                }
            </div>
        </form>
    }
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button (click)="handleCancel()" class="button secondary-button mr-2">
            Cancelar
        </button>

        <button nz-button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()" [nzLoading]="isSaving">
            Guardar
        </button>
    </div>
</div>
